export const Approvals = {
    LOADING_APPROVALS_LIST: "LOADING_APPROVALS_LIST",
    GET_APPROVALS_LIST: "GET_APPROVALS_LIST",
};
